export enum EVENT_NOTIFICATION_TYPE {
    ajaxSuccess = 0,
    ajaxFailure = 1,
    customAjaxError = 2,
    notification = 3
}